import React from "react";
import {Transfer,Row, Col,Input,Button,Icon } from 'antd';

class ExpExcel extends React.Component {
    static defaultProps = {
        excelName:undefined,
        columns:[]
    };

    constructor(props) {
        super(props);
        this.state = {
            dataSource:[],
            targetKeys:[],
            excelName:this.props.excelName,
            btnDisabled:true,
            exportParams:this.props.exportParams
        }
    }

    componentDidMount() {
        let dataSource=[];
        let targetKeys=[];
        this.props.columns.map((item,index) => {
            if(item.excel!==false){
                dataSource.push({
                    key:(item.excelKey?item.excelKey.toUpperCase():(item.dataIndex?item.dataIndex.toUpperCase():item.key.toUpperCase()))+"@"+item.title,
                    title:item.title
                });
                targetKeys.push((item.excelKey?item.excelKey.toUpperCase():(item.dataIndex?item.dataIndex.toUpperCase():item.key.toUpperCase()))+"@"+item.title);
            }
        });
        this.setState({
            dataSource:dataSource,
            targetKeys:targetKeys
        });
    }

    handleChange = (targetKeys, direction, moveKeys) => {
        if(direction=='left'){
            this.setState({targetKeys:targetKeys});
        }else{
            let newTargetKeys=[];
            for(let i=moveKeys.length;i<targetKeys.length;i++){
                newTargetKeys.push(targetKeys[i]);
            }
            for(let i=0;i<moveKeys.length;i++){
                newTargetKeys.push(moveKeys[i]);
            }
            this.setState({targetKeys:newTargetKeys});
        }
    }

    handleSelectChange = (sourceSelectedKeys,targetSelectedKeys) => {
        console.info(targetSelectedKeys);
        if(targetSelectedKeys.length>0){
            this.setState({
                btnDisabled:false,
                targetSelectedKeys:targetSelectedKeys
            });
        }else{
            this.setState({
                btnDisabled:true,
                targetSelectedKeys:targetSelectedKeys
            });
        }
    }

    handleFileNameChange = (e) => {
        this.setState({
            excelName:e.target.value
        });
    }

    moveLiDom = (title) => {
        let liObjs=document.getElementsByClassName("ant-transfer-list-content")[1].getElementsByClassName("ant-transfer-list-content-item");
        let obj=undefined;
        for(let i=0;i<liObjs.length;i++){
            if(liObjs[i].getAttribute("title")==title){
                obj=liObjs[i];
                break;
            }
        }
        let prevObj=obj.previousSibling;
        document.getElementsByClassName("ant-transfer-list-content")[1].insertBefore(obj.cloneNode(true),prevObj);
        obj.remove();
    }

    render() {
        return (
            <div>
                <Row>
                    <Col>
                        <Transfer
                            rowKey={record => record.key}
                            dataSource={this.state.dataSource}
                            titles={['待选择列', '已选择列']} 
                            targetKeys={this.state.targetKeys}
                            onChange={this.handleChange}
                            onSelectChange={this.handleSelectChange}
                            render={item => item.title}
                            showSearch={true}
                            lazy={false}
                            listStyle={{
                                width: 225,
                                height: 300,
                            }}
                        />
                            
                      </Col>                      
                </Row>
                <Row span="2">
                    <Col style={{padding:"10px"}}>
                         文件名：<Input value={this.state.excelName} onChange={this.handleFileNameChange} style={{width:"450px"}}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ExpExcel;


// WEBPACK FOOTER //
// ./components/common/NHTable/expexcel.js